export default "__VITE_ASSET__DWEBrXTm__"